import { GET_SSO_LOGIN_REQUIRED } from 'actions/Types';

function ssoLoginRequired(state = null, action) {
  if (action.type === `${GET_SSO_LOGIN_REQUIRED}_SUCCESS`) {
    return action.payload;
  }

  return state;
}

export default ssoLoginRequired;
